<ng-container *transloco="let t; read: 'cabinets'">
  <ng-container *transloco="let tGlobal">

    @if (vm$ | async; as vm) {
      <div class="componentContainer">
        <section class="xs12col componentHeader">
          @if (isNew) {
            <h1>{{t('title')}}</h1>
          }
          @if (!isNew) {
            @if (vm.cabinet; as cabinet) {
              <h1>{{ t('modifyTitle') }} {{ cabinet.name }}</h1>
            }
          }
        </section>
        <section class="oneCol">
          <div class="xs12col flexColumn">
            <div class="boxContainer">
              <div class="box">
                <form [formGroup]="cabinetForm">
                  <div class="xs12col m4col flexColumn">
                    <fieldset class="fieldsetContainer flexColumn">
                      <kendo-formfield>
                        <kendo-label [text]="t('name')">*</kendo-label>
                        <kendo-textbox
                          formControlName="name"
                          [readonly]="!('Permissions.Cabinets.Update' | permission)"
                        ></kendo-textbox>
                        @if (cabinetForm.get('name')?.hasError('nameIsNotUnique') && (cabinetForm.get('name')?.touched || cabinetForm.get('name')?.dirty)) {
                          <span class="error-text">{{ tGlobal('global.errors.cabinet.nameIsNotUnique') }}</span>
                        }
                      </kendo-formfield>
                      <kendo-formfield>
                        <kendo-label [text]="t('location')"></kendo-label>
                        <kendo-textbox
                          formControlName="location"
                          [readonly]="!('Permissions.Cabinets.Update' | permission)"
                        ></kendo-textbox>
                      </kendo-formfield>
                    </fieldset>
                  </div>
                  @if (!isNew) {
                    <app-slot-view-admin
                      class="xs12col m8col"
                      [cabinetId]="cabinetId"
                      (sortingChanged)="handleSortingChange($event)"
                      [isAdmin]="isAdmin">
                    </app-slot-view-admin>
                  }
                  <div class="buttonContainer flex-wrap">
                    <button
                      class="buttonSecondary padding-right-medium"
                      [routerLink]="('Permissions.Cabinets.SearchGlobal' | permission) ? ['/companies', companyId] : ['/cabinets']"
                      >
                      {{ tGlobal('global.back') }}
                    </button>
                    <button
                      kendoButton
                      class="buttonPrimary"
                      type="submit"
                      (click)="saveChanges()"
                      [hidden]="!('Permissions.Cabinets.Update' | permission)"
                      [disabled]="cabinetForm?.invalid || !cabinetForm?.dirty">
                      {{ isNew ? t('submit') : t('save') }}
                    </button>
                  </div>
                  <div class="buttonContainer flex-wrap margin-top-medium">
                    <button
                      kendoButton
                      loadingIndication="/cabinets/exportCabinet"
                      class="addIcon align-center"
                      (click)="exportCabinet(vm.cabinet)"
                      [hidden]="isNew || !('Permissions.Cabinets.Export' | permission)">
                      <span class="k-button-text">
                        @if (vm.loadingExport) {
                          <span class="icon spinner">
                            <img src="../../../assets/icons/reload.svg">
                          </span>
                        } @else {
                          <span class="icon rotate180">
                            <img src="../../../assets/icons/download-icon.svg">
                          </span>
                        }
                        <span>{{tGlobal('export')}}</span>
                      </span>
                      <span  class="tooltipContainer">
                        <span [attr.tooltip]="t('tooltipExport')" flow="right" class="tooltipContainer">
                          <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                        </span>
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <button
              type="delete"
              (click)="deletionDialogOpen()"
              class="buttonSecondary padding-top-medium padding-bottom-medium"
              [hidden]="isNew || !('Permissions.Cabinets.Delete' | permission)">{{tGlobal('global.delete')}}
            </button>
          </div>
        </section>
      </div>
      @if (deletionDialogOpened) {
        <kendo-dialog
          title="{{t('confirmDeletion')}}"
          (close)="deletionDialogClose('cancel')"
          [minWidth]="250"
          [width]="450">
          <p style="margin: 30px; text-align: center;">
            {{t('deletionMessage')}}
          </p>
          <kendo-dialog-actions>
            <button kendoButton (click)="deletionDialogClose('cancel')">{{ t('cancel') }}</button>
            <button kendoButton (click)="deletionDialogClose('delete')" themeColor="primary">{{ t('delete') }}
            </button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
    }
    <ng-container>
    </ng-container>